import { EmailData } from '../types/results.types';

// Statuses that mean the email has already been handled — hide the Verify button.
// UNKNOWN is intentionally excluded: it means Bouncer had a transient failure and the
// email is still retriable.
const ALREADY_HANDLED = new Set<string>([
  'GUARANTEED',
  'RISKY',
  'INVALID',
  'GENERIC',
  'PENDING',
]);

const INBOX_FULL_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const isFreshInboxFull = (email: EmailData): boolean => {
  if (email.verification_status !== 'INBOX_FULL') return false;
  if (!email.verified_at) return true;
  return Date.now() - new Date(email.verified_at).getTime() < INBOX_FULL_TTL_MS;
};

export const isVerifiable = (e: EmailData): boolean =>
  !!e.id &&
  !e.is_catch_all &&
  !e.is_guessed &&
  !isFreshInboxFull(e) &&
  !(e.verification_status && ALREADY_HANDLED.has(e.verification_status)) &&
  !(typeof e.ai_score === 'number' && e.ai_score > 3);
